<template>

    <div class="checklist">
        <div class="checklist-header">
            <span class="checklist-title">Checklist</span>
        </div>
        <div class="checklist-body">
            <div v-for="item in items" :key="item.slug">
                <router-link v-if="item.name" :to="{ name: item.name }" class="checklist-item" :class="{ 'complete': steps[item.slug] }">
                    <div class="d-flex align-items-center">
                        <i v-if="steps[item.slug]" class="fas fa-check-circle text-primary fs-22 mr-10"></i>
                        <i v-else class="far fa-circle fs-22 mr-10"></i>
                        <span class="label">{{ item.label }}</span>
                    </div>
                    <i class="fas fa-chevron-right arrow"></i>
                </router-link>
                <a v-if="item.link" :href="item.link" target="_blank" class="checklist-item" :class="{ 'complete': steps[item.slug] }">
                    <div class="d-flex align-items-center">
                        <i v-if="steps[item.slug]" class="fas fa-check-circle text-primary fs-22 mr-10"></i>
                        <i v-else class="far fa-circle fs-22 mr-10"></i>
                        <span class="label">{{ item.label }}</span>
                    </div>
                    <i class="fas fa-chevron-right arrow"></i>
                </a>
            </div>
        </div>
    </div>

</template>

<style lang="scss">

    .checklist {
        background: $color-bg;
        border: 1px solid $color-rule;
        border-radius: 5px;
        height: auto;
        margin-left: 30px;
        width: 40%;
        .checklist-header {
            border-bottom: 1px solid $color-rule;
            padding: 15px 20px;
            .checklist-title {
                @include font-medium(15px);
                color: $color-text;
            }
        }
        .checklist-body {
            padding: 30px;
            .checklist-item {
                @include font-medium(14px);
                align-items: center;
                color: $color-text;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                padding: 7px 0;
                text-decoration: none;
                transition: color .3s;
                &:hover {
                    color: $color-primary-hover;
                }
                &.complete .label {
                    opacity: 0.8;
                    text-decoration: line-through;
                }
                .arrow {
                    opacity: 0.5;
                }
            }
        }
    }

</style>

<script>

import CompanyApi from '@api/CompanyApi';

export default {

    data() {
        return {
            loading: false,
            items: [
                {
                    'slug': 'project-created',
                    'label': 'Create a project',
                    'name': 'projects',
                },
                {
                    'slug': 'domain-created',
                    'label': 'Add a sending domain',
                    'name': 'settings-domain',
                },
                {
                    'slug': 'domain-verified',
                    'label': 'Verify your sending domain',
                    'name': 'settings-domain',
                },
                {
                    'slug': 'customer-identified',
                    'label': 'Identify a customer',
                    'link': 'https://docs.crowdpower.io/getting-started/javascript-tag/identify-customer',
                },
                {
                    'slug': 'event-performed',
                    'label': 'Record an event',
                    'link': 'hhttps://docs.crowdpower.io/getting-started/javascript-tag/create-customer-event',
                },
                {
                    'slug': 'automation-created',
                    'label': 'Create an automation',
                    'name': 'automations',
                },
                {
                    'slug': 'automation-started',
                    'label': 'Start an automation',
                    'name': 'automations',
                },
                {
                    'slug': 'segment-created',
                    'label': 'Create a segment',
                    'name': 'segments',
                },
                {
                    'slug': 'upgraded',
                    'label': 'Upgrade your plan 🎉',
                    'name': 'billing',
                },
            ],
        }
    },

    computed: {

        steps() {
            return this.$store.getters.company.steps;
        },

    },

    mounted() {
        this.getCompany();
    },

    methods: {

        getCompany() {
            this.loading = true;
            CompanyApi.getCompany(this.$store.getters.company.id)
                .then((response) => {
                    this.loading = false;
                }, () => {
                    this.loading = false;
                });
        },

    },

}

</script>
